import { Check, Star } from "lucide-react";
import { MEMBERSHIPS } from "@/data/site";
import SEO from "@/components/SEO";
import { Reveal, MaskedLines } from "@/components/Reveal";
import { BookButton } from "@/components/CTAButtons";
import { CTABanner } from "@/components/sections";

export default function Memberships() {
  return (
    <>
      <SEO
        title="Memberships & Packages — NYC Salon Membership, Hell's Kitchen"
        description="Save on hair, nails, facials and waxing with a Maison Neuf membership in Hell's Kitchen, NYC. Monthly services, member pricing, priority booking and exclusive perks."
      />
      <section className="mx-auto max-w-[1400px] px-5 pt-36 pb-16 md:px-10 md:pt-44" data-testid="memberships-hero">
        <p className="label mb-6 text-wine">Memberships & Packages</p>
        <h1 className="max-w-4xl font-display text-5xl leading-[1.0] md:text-8xl">
          <MaskedLines lines={["Self-care,", "on subscription."]} />
        </h1>
        <p className="mt-8 max-w-xl text-muted-foreground md:text-lg">
          Consistency is the secret to great hair and skin. Members save on every visit, book first, and unlock perks reserved for the house.
        </p>
      </section>

      <section className="mx-auto max-w-[1400px] px-5 pb-24 md:px-10" data-testid="membership-tiers">
        <div className="grid gap-px bg-border md:grid-cols-3">
          {MEMBERSHIPS.map((m, i) => (
            <Reveal key={m.name} delay={i * 0.1}>
              <div className={`relative flex h-full flex-col bg-background p-8 md:p-10 ${m.featured ? "ring-1 ring-wine" : ""}`} data-testid={`membership-${i}`}>
                {m.featured && (
                  <span className="absolute right-6 top-6 inline-flex items-center gap-1 bg-wine px-3 py-1 font-mono text-[0.6rem] uppercase tracking-[0.14em] text-white">
                    <Star className="h-3 w-3 fill-current" /> Most loved
                  </span>
                )}
                <p className="label mb-5">{m.name}</p>
                <div className="flex items-baseline gap-1">
                  <span className="font-display text-5xl">{m.price}</span>
                  <span className="text-muted-foreground">{m.cadence}</span>
                </div>
                <ul className="mt-8 flex-1 space-y-4">
                  {m.perks.map((p) => (
                    <li key={p} className="flex gap-3 text-sm text-foreground/90">
                      <Check className="mt-0.5 h-4 w-4 shrink-0 text-wine" strokeWidth={2} /> {p}
                    </li>
                  ))}
                </ul>
                <div className="mt-10">
                  <BookButton label="Become a member" solid={m.featured} testid={`membership-join-${i}`} className="w-full justify-center" />
                </div>
              </div>
            </Reveal>
          ))}
        </div>
        <p className="mt-8 text-sm text-muted-foreground">Memberships auto-renew monthly and can be paused or cancelled with 30 days' notice. Gift cards and prepaid packages also available — just ask.</p>
      </section>

      <CTABanner title="Join the house." sub="Start a membership online, or call to build a custom package." />
    </>
  );
}
